import { useQuery } from 'react-query';
import { fetchPopularMovies } from '../services/api';

export const usePopularMovies = options => {
  return useQuery('popularMovies', fetchPopularMovies, options);
};
